// src/pages/Terms.jsx
import React from 'react';

const styles = {
  page: {
    minHeight: '100vh',
    background: 'var(--ka-navy)',
    color: 'var(--ka-white)',
    padding: '60px 40px',
    position: 'relative',
    overflow: 'hidden',
  },
  bgPattern: {
    position: 'absolute',
    inset: 0,
    backgroundImage: `
      radial-gradient(ellipse at 20% 50%, rgba(200,151,58,0.08) 0%, transparent 60%),
      radial-gradient(ellipse at 80% 20%, rgba(200,151,58,0.05) 0%, transparent 50%)
    `,
    pointerEvents: 'none',
  },
  inner: {
    maxWidth: 720,
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 48,
    textDecoration: 'none',
  },
  kaCircle: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    background: 'var(--ka-gold)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 18,
    fontWeight: 800,
    fontFamily: 'var(--font-display)',
    color: 'var(--ka-navy)',
  },
  kaName: {
    fontFamily: 'var(--font-display)',
    fontSize: 18,
    fontWeight: 700,
    color: 'var(--ka-white)',
    lineHeight: 1.2,
  },
  kaSub: {
    fontSize: 10,
    color: 'var(--ka-gold-light)',
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    marginTop: 2,
  },
  divider: {
    width: 48,
    height: 3,
    background: 'var(--ka-gold)',
    borderRadius: 2,
    margin: '20px 0 32px',
  },
  h1: {
    fontFamily: 'var(--font-display)',
    fontSize: 36,
    fontWeight: 700,
    color: 'var(--ka-white)',
    marginBottom: 4,
  },
  updated: {
    fontSize: 13,
    color: 'rgba(255,255,255,0.4)',
    marginBottom: 40,
  },
  h2: {
    fontFamily: 'var(--font-display)',
    fontSize: 18,
    fontWeight: 700,
    color: 'var(--ka-gold)',
    marginTop: 36,
    marginBottom: 10,
  },
  p: {
    fontSize: 15,
    color: 'rgba(255,255,255,0.75)',
    lineHeight: 1.8,
    marginBottom: 16,
  },
  link: {
    color: 'var(--ka-gold)',
    textDecoration: 'none',
  },
  footer: {
    marginTop: 64,
    paddingTop: 24,
    borderTop: '1px solid rgba(255,255,255,0.1)',
    fontSize: 12,
    color: 'rgba(255,255,255,0.3)',
    textAlign: 'center',
  },
};

export default function Terms() {
  return (
    <div style={styles.page}>
      <div style={styles.bgPattern} />
      <div style={styles.inner}>

        <a href="/" style={styles.badge}>
          <div style={styles.kaCircle}>KA</div>
          <div>
            <div style={styles.kaName}>King's Academy</div>
            <div style={styles.kaSub}>Madaba, Jordan</div>
          </div>
        </a>

        <h1 style={styles.h1}>Terms of Use</h1>
        <div style={styles.divider} />
        <p style={styles.updated}>Last updated: March 2026</p>

        <p style={styles.p}>
          The King's Academy Faculty Tool Kit is an internal portal provided by
          King's Academy for use by its faculty and staff. By signing in, you
          agree to the following terms.
        </p>

        <h2 style={styles.h2}>Who can use this portal</h2>
        <p style={styles.p}>
          Access is limited to current King's Academy faculty and staff with an
          active school Google account. You are responsible for keeping your
          account credentials secure and for any activity that occurs under your
          account.
        </p>

        <h2 style={styles.h2}>Acceptable use</h2>
        <p style={styles.p}>
          The portal is provided for professional use in support of your work at
          King's Academy. Please use it responsibly and in accordance with the
          school's existing policies and code of conduct. Do not attempt to
          access areas of the portal beyond your assigned permissions, or use the
          portal in any way that could disrupt its operation for others.
        </p>

        <h2 style={styles.h2}>Data and content</h2>
        <p style={styles.p}>
          Content you create or submit through the portal — such as survey
          responses or other tool outputs — remains the property of King's
          Academy and may be accessible to administrators. Do not enter sensitive
          personal data about students or third parties unless a specific tool is
          designed for that purpose.
        </p>

        <h2 style={styles.h2}>Availability</h2>
        <p style={styles.p}>
          We do our best to keep the portal running smoothly, but we cannot
          guarantee uninterrupted access. The portal may occasionally be
          unavailable due to maintenance or technical issues. We are not liable
          for any inconvenience caused by downtime.
        </p>

        <h2 style={styles.h2}>Changes to these terms</h2>
        <p style={styles.p}>
          These terms may be updated from time to time. Continued use of the
          portal after any changes constitutes acceptance of the updated terms.
          We'll do our best to communicate significant changes in advance.
        </p>

        <h2 style={styles.h2}>Questions</h2>
        <p style={styles.p}>
          If you have any questions about these terms, please contact:{' '}
          <a href="mailto:techcommunications@kingsacademy.edu.jo" style={styles.link}>
            techcommunications@kingsacademy.edu.jo
          </a>
        </p>

        <div style={styles.footer}>
          King's Academy · Madaba, Jordan · Faculty Tool Kit
        </div>
      </div>
    </div>
  );
}